import { OfferPriceButton } from "./OfferPriceButton.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/offer-pricing/CashOfferPriceButton.tsx
const CashOfferPriceButton = ({ price, onClick, isSelected }) => {
	const { t } = useTranslation("phx-lib");
	const subtitle = price ? t("pricing.withoutInsurance") : t("pricing.unknown");
	return /* @__PURE__ */ jsx(OfferPriceButton, {
		title: t("pricing.smartPrice"),
		subtitle,
		isSelected,
		onClick,
		price
	});
};

//#endregion
export { CashOfferPriceButton };